let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kQFyD")).then(() => parcelRequire('eL6FX'));